import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  AccountTransactions,
  Login,
  MerchantProfile,
  MyDocuments,
  ProductsAndServices,
  PageNotFound,
  PaymentServicesDashboard,
  Terminals,
  TerminalTransactions,
  VodapayDeals,
} from '../index';
import ForgotPasswordMerchantId from './forgot-password/merchant-id/forgot-password-merchant-id';
import ForgotPasswordResendOtp from './forgot-password/resend-otp/forgot-password-resend-otp';
import FirstTimeUserMerchantId from './first-time-user-activation/first-time-user-merchant-id';
import ForgotPasswordOtp from './forgot-password/merchant-otp/forgot-password-otp';
import { authRequired } from 'src/routing/auth-required';
import ChangePassword from './forgot-password/change-password/change-password';
import { MerchantProfileProvider } from 'src/context/merchant-profile-context';
import { OfferProvider } from 'src/context/offer-context';
import SessionManagement from 'src/components/session-management/session-management';
import { wrapWithNavigation } from 'src/routing/navigation-wrapper';
import BusinessCashAdvance from './business-cash-advance/business-cash-advance';
import {
  bizWalletProDashboardRoute,
  bizWalletProTransactionsRoute,
  businessCashAdvanceRoute,
  documentsRoute,
  firstTimeLoginOtpRoute,
  generatePaymentRequestRoute,
  merchantLoginRoute,
  merchantProfileRoute,
  paymentsDashboardRoute,
  productsAndServicesRoute,
  resetPasswordMerchantIdRoute,
  resetPasswordOtpRoute,
  resetPasswordResendOtpRoute,
  setPasswordRoute,
  terminalsRoute,
  terminalTransactionsRoute,
  transactionsRoute,
  vodapayDealsRoute,
} from 'src/routing/routes';
import BizWalletProDashboard from './biz-wallet-pro/biz-wallet-pro-dashboard/biz-wallet-pro-dashboard';
import BizWalletProTransactions from './biz-wallet-pro/biz-wallet-pro-transactions/biz-wallet-pro-transactions';
import { Environment } from 'src/Environment';
import TechnicalErrorSelfService from './technical-error-self-service/technical-error-self-service';
import GeneratePaymentRequest from 'src/containers/self-service/generate-payment-request/generate-payment-request';

export default function SelfService() {
  return (
    <TechnicalErrorSelfService fullPage>
      <Switch>
        <Route exact path={merchantLoginRoute} component={Login} />
        <Route exact path={resetPasswordMerchantIdRoute} component={ForgotPasswordMerchantId} />
        <Route exact path={resetPasswordResendOtpRoute} component={ForgotPasswordResendOtp} />
        <Route exact path={firstTimeLoginOtpRoute} component={FirstTimeUserMerchantId} />
        <Route exact path={resetPasswordOtpRoute} component={ForgotPasswordOtp} />
        <Route exact path={setPasswordRoute} component={authRequired(ChangePassword, {}, true)} />
        <MerchantProfileProvider>
          <OfferProvider>
            <SessionManagement />
            <Switch>
              <Route
                exact
                path={paymentsDashboardRoute}
                component={authRequired(wrapWithNavigation(PaymentServicesDashboard))}
              />
              <Route
                exact
                path={terminalsRoute}
                component={authRequired(wrapWithNavigation(Terminals))}
              />
              <Route
                path={businessCashAdvanceRoute}
                component={authRequired(wrapWithNavigation(BusinessCashAdvance))}
              />
              <Route
                exact
                path={merchantProfileRoute}
                component={authRequired(wrapWithNavigation(MerchantProfile))}
              />
              <Route
                exact
                path={transactionsRoute}
                component={authRequired(wrapWithNavigation(AccountTransactions))}
              />
              <Route
                exact
                path={terminalTransactionsRoute}
                component={authRequired(wrapWithNavigation(TerminalTransactions))}
              />
              <Route
                exact
                path={documentsRoute}
                component={authRequired(wrapWithNavigation(MyDocuments))}
              />
              {!Environment.current?.disabledFeatures?.valueAddedServices && (
                <Route
                  exact
                  path={productsAndServicesRoute}
                  component={authRequired(wrapWithNavigation(ProductsAndServices))}
                />
              )}
              <Route
                exact
                path={bizWalletProDashboardRoute}
                component={authRequired(wrapWithNavigation(BizWalletProDashboard))}
              />
              <Route
                exact
                path={bizWalletProTransactionsRoute}
                component={authRequired(wrapWithNavigation(BizWalletProTransactions))}
              />
              <Route
                exact
                path={generatePaymentRequestRoute}
                component={authRequired(wrapWithNavigation(GeneratePaymentRequest))}
              />
              <Route
                exact
                path={vodapayDealsRoute}
                component={authRequired(wrapWithNavigation(VodapayDeals))}
              />
              <Route component={PageNotFound} />
            </Switch>
          </OfferProvider>
        </MerchantProfileProvider>
      </Switch>
    </TechnicalErrorSelfService>
  );
}
